(function () {
  const widgetSelectors = [
    'ryviu-widget-total',
    '[data-ryviu-widget]',
    '.review-widget',
    '.ryviu-widget',
    '.ryviu-widget-total',
    '.ryviu-badge'
  ].join(',');

  const ratingSelectors = [
    '.ryviu-badge',
    '[class*="ryviu-starrating"]',
    '[class*="r--stars"]',
    '[class*="star-rating"]'
  ].join(',');

  const iconSelectors = [
    'em[class*="ryviu-icon"]',
    'span[class*="Ry-Icon"]',
    '[class*="r-icon"]',
    '[class*="r--stars-icon"]',
    '.ryviu-badge i',
    '.ryviu-badge em',
    '.spr-icon'
  ].join(',');

  const countSelectors = [
    '.ryviu-total-reviews',
    '.ryviu-number-reviews',
    '[class*="review-count"]'
  ].join(',');

  function hasWidgets(root) {
    const scope = root && root.querySelector ? root : document;
    return !!scope.querySelector(widgetSelectors);
  }

  function normalizeWidget(widget) {
    widget.style.maxWidth = '100%';

    widget.querySelectorAll(ratingSelectors).forEach(function (rating) {
      rating.style.display = 'inline-flex';
      rating.style.alignItems = 'center';
      rating.style.alignContent = 'center';
      rating.style.flexWrap = 'nowrap';
      rating.style.whiteSpace = 'nowrap';
      rating.style.lineHeight = '1';
      rating.style.verticalAlign = 'middle';
      rating.style.gap = '0';
    });

    widget.querySelectorAll(iconSelectors).forEach(function (icon) {
      icon.style.display = 'inline-block';
      icon.style.float = 'none';
      icon.style.fontStyle = 'normal';
      icon.style.lineHeight = '1';
      icon.style.letterSpacing = '0';
      icon.style.verticalAlign = 'middle';
      icon.style.transform = 'none';
    });

    widget.querySelectorAll(countSelectors).forEach(function (count) {
      count.style.display = 'inline-block';
      count.style.whiteSpace = 'nowrap';
      count.style.lineHeight = '1.2';
      count.style.verticalAlign = 'middle';
      if (!count.style.marginLeft) {
        count.style.marginLeft = '6px';
      }
    });
  }

  function applyReviewFixes(root) {
    const scope = root && root.querySelectorAll ? root : document;

    if (!hasWidgets(scope)) {
      return;
    }

    scope.querySelectorAll(widgetSelectors).forEach(normalizeWidget);
  }

  let scheduled = false;
  let pollingTimer = null;

  function queueApply(root) {
    if (!hasWidgets(root || document)) {
      return;
    }

    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      applyReviewFixes(root || document);
    });
  }

  function startPolling() {
    let attempts = 0;

    if (!hasWidgets(document)) {
      return;
    }

    if (pollingTimer) {
      window.clearInterval(pollingTimer);
    }

    pollingTimer = window.setInterval(function () {
      attempts += 1;
      queueApply(document);

      if (attempts >= 8) {
        window.clearInterval(pollingTimer);
        pollingTimer = null;
      }
    }, 500);
  }

  document.addEventListener('DOMContentLoaded', function () {
    queueApply(document);
    startPolling();
  });

  window.addEventListener('load', function () {
    queueApply(document);
    startPolling();
  });

  document.addEventListener('shopify:section:load', function (event) {
    queueApply(event.target || document);
  });

  document.addEventListener('ecom-products-init', function (event) {
    queueApply(event.target || document);
  });
})();
